function processText(text, context) {
  text = text.replaceAll("|PATIENT-TYPE|", context.patientType || "this patient's type");
  text = text.replaceAll("|PROVIDER-NAME|", context.providerName || "this provider");
  text = text.replaceAll("|PROVIDER-PHONE-NUMBER|", telLink(context.providerPhoneNumber) || "this provider's number");
  text = text.replaceAll("|PROVIDER-TYPE|", context.providerType || "this provider's type");
  text = text.replaceAll(
    "|PROVIDER-TYPE-DESCRIPTION|",
    context.providerTypeDescription || "a description of this provider's type",
  );
  text = text.replaceAll(
    "|PROVIDER-LICENSED-STATES|",
    arrayToUL(context.providerLicensedStateNames) || "this provider's licensed states",
  );
  text = text.replaceAll("|SELECTED-STATE|", context.selectedStateName || "the selected state");
  text = text.replaceAll("|SELECTED-VISIT-TYPE|", context.visitType?.name || "the selected visit type");
  text = text.replaceAll(
    "LICENSED-PROVIDER-SEARCH-URL",
    context.licensedProviderSearchUrl?.replace("SELECTED-STATE-NAME", context.selectedStateName),
  );

  return text;
}

function telLink(phoneNumber) {
  if (!phoneNumber) {
    return;
  }

  return `<a href="tel:${phoneNumber}">${phoneNumber}</a>`;
}

function arrayToUL(array) {
  if (!array) {
    return;
  }

  return `<ul>${array.map((element) => `<li>${element}</li>`).join("")}</ul>`;
}

export function useSnippetProcessor() {
  return {
    processText,
  };
}
